<template>
	<PurchasePage 
		ref="capitalPage"
		:tabs="[]"
		:show-total-count="true"
		:total-count-label="'资金列表'"
		:show-time-filter="false"
		:search-fields="searchFields"
		:columns="columns"
		:show-expand="false"
		:show-operation="false"
		:query="purchaseReceiptPage"
	>
		<!-- 自定义已支付金额列 -->
		<template #paidAmount="{ row }">
			<div>￥{{ row.paidAmount }}</div>
		</template>
	</PurchasePage>
</template>

<script>
	import { mapActions } from 'vuex'
	export default{
		data(){
			return{
				searchFields: [
					{ prop: 'time', type: 'date', label: '收款日期', placeholder: '请选择日期', width: '180px' },
					{ prop: 'wd', type: 'input', placeholder: '请输入名字、企业等关键字', width: '240px' },
				],
				columns:[
					{ label: '收款时间', prop: 'collectionTime', width: '150' },
					{ label: '买方名称', prop: 'buyerName', width: '150' },
					{ label: '买方企业名称', prop: 'buyerEnterpriseName', minWidth: '180' },
					{ label: '卖方名称', prop: 'sellerName', width: '150' },
					{ label: '卖方企业名称', prop: 'sellerEnterpriseName', minWidth: '180' },
					{ label: '已支付金额', prop: 'paidAmount', width: '150' },
				],
			}
		},
		methods:{
			...mapActions('mysaleMudule',[
				'purchaseReceiptPage',  //获取用户资金列表
			]),
		},
	}
</script>

<style scoped lang="less">
	
</style>
